<template>
  <div>
  <initio-panel @submit-handler="submitHandler" :errors="errors" :hide-submit="true">
    <template v-slot:title>
      Confirm your car cover
    </template>
    <template v-slot:sidebar>

       <initio-quote-overview location="top" v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')" v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly" v-bind:can_convert_to_monthly="canConvertToMonthly">
        </initio-quote-overview>
      <br />
      <initio-quote-overview class="is-hidden-mobile" v-on:emitModalMonthlyInsurance="toggleModal('How monthly works')" location="bottom" v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly" v-bind:can_convert_to_monthly="canConvertToMonthly">
        </initio-quote-overview>
    </template>
    <template v-slot:form_footer>
      <hr />

      <div class="notification is-info-blue" v-if="quoteDiscountResellerName">
        <strong>Discount applied.</strong> Your {{ quoteDiscountResellerName }} discount has been applied.
      </div>

      <div class="columns" v-if="!isLoggedIn">
        <div class="column has-text-centered">
          <strong>Already have insurance with us?</strong> <a href="/app/login?redirect=/spa/vehicle/new">Login</a>
        </div>
      </div>

      <div class="columns" v-if="canConvertToMonthly">

        <div class="column">
          <div class="box quote-box" :class="{'is-loading': quoteIsLoading}" data-item="monthly">
            <SpinnerSvg class="loading-spinner" />

            <div class="quote-box__monthly-benefit has-text-centered">
              <div class="is-uppercase">Monthly
                <a href="#" @click.prevent="toggleModal('How monthly works')" class="how-monthly-works-icon-link">i</a>
              </div>
            </div>

            <div class="columns is-centered is-multiline">
              <div class="column is-10 mt-4 has-text-centered" v-if="!quoteErrors">
                <h5 class="has-text-primary title is-size-7 mb-2 has-text-weight-black" v-if="quotePremiumDiscountAmount">Discount of {{quotePremiumDiscountAmount | toCurrency}}</h5>
                <h3 class="title mb-2 has-text-weight-black"><sup class="is-size-6">$</sup> <span v-if="quotePremiumMonthly">{{quotePremiumMonthly | toCurrencyNoSymbol}}</span></h3>
                <p class="has-text-grey is-size-7 mb-5">Monthly payment, NZD, inc GST.</p>
                <button type="button" class="button is-cta is-large is-fullwidth has-text-weight-bold" @click="setPaymentIntervalAndSubmit('monthly')"><span class="is-size-5-mobile is-size-5-widescreen is-size-6-tablet">Renew Monthly</span></button>
                <p class="has-text-grey is-size-7 mt-2">Credit card payment only</p>
              </div>
              <div class="column is-10 has-text-centered" v-if="quoteErrors">
                <div class="notification is-danger">
                  There was a problem loading the quote, please try again
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="box quote-box" :class="{'is-loading': quoteIsLoading}" data-item="yearly">
            <SpinnerSvg class="loading-spinner" />

            <div class="quote-box__monthly-benefit has-text-centered">
              <div class="is-uppercase">Yearly</div>
            </div>

            <div class="columns is-centered is-multiline">
              <div class="column is-10 mt-4 has-text-centered" v-if="!quoteErrors">
                <h5 class="has-text-primary title is-size-7 mb-2 has-text-weight-black" v-if="quotePremiumDiscountAmount">Discount of {{quotePremiumDiscountAmount | toCurrency}}</h5>
                <h3 class="title mb-2 has-text-weight-black"><sup class="is-size-6">$</sup> <span v-if="quotePremiumYearly">{{ quotePremiumYearly | toCurrencyNoSymbol}}</span></h3>
                <p class="has-text-grey is-size-7 mb-5">Payment for year, NZD, inc GST.</p>
                <button type="button" class="button is-cta is-large is-fullwidth has-text-weight-bold" @click="setPaymentIntervalAndSubmit('yearly')"><span class="is-size-5-mobile is-size-5-widescreen is-size-6-tablet">Renew Annually</span></button>
                <p class="has-text-grey is-size-7 mt-2">Credit card, Online EFTPOS or Account2Account</p>
              </div>
              <div class="column is-10 has-text-centered" v-if="quoteErrors">
                <div class="notification is-danger">
                  There was a problem loading the quote, please try again
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="box quote-box" v-else :class="{'is-loading': quoteIsLoading}">
        <SpinnerSvg class="loading-spinner" />
        <div class="columns mt-4 is-centered is-flex">
          <div class="column">
            <InlineText
                :label="paymentInterval(true) + ' Payment'"
                :tooltip="paymentInterval() == 'monthly' ? 'This is the amount we will charge your selected debit or credit card each month. The cover automatically renews next month.' : null"
            />
          </div>
          <div class="column is-narrow has-text-right" v-if="quotePremiumDiscountAmount !== null">
            <h3 class="title mb-2 has-text-weight-black"><sup class="is-size-6">$</sup> <span v-if="quotePremiumYearly">{{ quotePremiumYearly | toCurrencyNoSymbol}}</span></h3>
            <h5 class="has-text-primary title has-text-weight-bold is-size-7" v-if="quotePremiumDiscountAmount">Discount of {{quotePremiumDiscountAmount|toCurrency}}</h5>
          </div>
        </div>
        <div class="columns is-flex border-top-bottom">
          <div class="column has-text-right" v-if="!quoteErrors">
            <p class="has-text-grey is-size-7">NZD, inc GST</p>
          </div>
        </div>
        <footer class="box-adjustment">
          <div class="columns is-centered is-multiline">
            <div class="column is-4 mt-4 has-text-centered" v-if="!quoteErrors">
              <button class="button  is-large is-fullwidth has-text-weight-bold is-cta">Continue</button>
              <p class="has-text-grey is-size-7 mt-2">Credit card, Online EFTPOS or Account2Account</p>
            </div>
            <div class="column is-4 has-text-centered" v-if="quoteErrors">
              <div class="notification is-danger">
                There was a problem loading the quote, please try again
              </div>
            </div>
          </div>
        </footer>
      </div>

      <payment-breakdown-graph :breakdownsByInterval="quoteBreakdownsByInterval" />

      <initio-quote-overview class="is-visible-mobile" location="bottom" v-bind:quote_premium="quotePremiumMonthly" v-bind:quote_premium_annual="quotePremiumYearly" v-bind:can_convert_to_monthly="canConvertToMonthly">
        </initio-quote-overview>
    </template>
    <template v-slot:after_form>
      <div v-if="debugList.length" class="columns">
        <div class="column" v-for="(debug_by_payment_interval, index) in debugList" :key="index">
          <div class="quote_debug is-hidden-mobile">
            <div class="box">
              <h4 class="subtitle is-5">Debug {{ debug_by_payment_interval.type }}</h4>
              <div class="content">
                <ol>
                  <li v-for="(item, index)  in debug_by_payment_interval.quote_debug" :key="index">
                    <div v-html="item"></div>
                  </li>
                </ol>
                <hr />
                <code>
                  Input vars
                  <ol>
                    <li v-for="(item, index)  in debug_by_payment_interval.quote_input_debug" :key="index">
                      {{ index }}: <span v-html="item"></span>
                    </li>
                  </ol>
                </code>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </initio-panel>

  <modal
      v-if="modalOpen"
      :class="{ 'is-active': modalOpen }"
      v-on:childToParent="toggleModal"
      :title="modalTitle"
  >


    <div v-if="modalTitle === 'How monthly works'">
      <table width="100%" border="0" cellpadding="0" cellspacing="0" class="table">
        <tbody><tr><td>Month to month insurance policy (just like a subscription)</td></tr>
        <tr><td>We automatically renew your policy each month (always insured)</td></tr>
        <tr><td>Your selected credit card is charged with the monthly premium</td></tr>
        <tr><td>We always tell you when we have renewed and charged your card</td></tr>
        <tr><td>You can cancel or change your monthly insurance anytime</td></tr>
        <tr><td>We always tell you what next month's insurance cost will be</td></tr>
        <tr><td>We let you know if your card declines or expires</td></tr>
        </tbody>
      </table>
      <strong>Why does Monthly cost more?</strong>
      <p>With a monthly payment we don't receive all of the money upfront.  This affects how the insurer funds customer claim payments. In addition, there is more cost associated with payment processing as there are a greater number of transactions. </p>
      <p><a class="" href="/how-monthly-insurance-works" target="_blank">Learn more</a></p>
    </div>
  </modal>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioQuoteOverview from '@/components/partials/QuoteOverview.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import SpinnerSvg from '@/components/partials/SpinnerSvg.vue'

import debounce from "lodash.debounce";
import { mapGetters } from 'vuex'
const axios = require("axios");
import PaymentBreakdownGraph from '@/components/partials/PaymentBreakdownGraph.vue'

// import VueRouter from 'vue-router'
import { api } from '@/store/store.js';

export default {
  components: {
    InitioPanel,
    InitioQuoteOverview,
    SpinnerSvg,
    PaymentBreakdownGraph
  },
  mixins: [
    stepSubmit
  ],
  methods: {
    submitHandler() {
      let context = this;

      // Get the current payment interval (either from selectedPaymentInterval or from answers)
      const currentInterval = this.selectedPaymentInterval || this.answers['VehicleRenew.Quote'].payment_interval;

      // Store the premium for the selected payment interval
      const selectedPremium = currentInterval === 'monthly'
        ? this.quotePremiumMonthly
        : this.quotePremiumYearly;

      // Store in backendData to persist through navigation (like new policy flow does)
      this.$store.commit('updateBackendData', {
          'VehicleRenew.Quote': {
            vehicle_quote_premium_raw: selectedPremium,
            vehicle_quote_discount_raw: this.quotePremiumDiscountAmount,
            payment_interval: currentInterval
          }
        }
      );

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
          
        }, error => {
          console.error("VehicleQuote Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    },
    resetDebug() {
      this.debugList =  [];
    },
    getQuote:   debounce(function(updatedAnswers) {
      this.quoteIsLoading = true;
      this.quoteErrors = false;
      // console.log(this.sessionId());

      // There is a bit of a delay while the slider component gets ready and returns a value.
      // Just keep the loading icon until we get a vehicle_cover_type
      const cover_type = updatedAnswers['VehicleRenew.Quote']['vehicle_cover_type'];
      if( ! cover_type ){
        return false;
      }

      // Also keep loading/waiting unless we have a sum_insured that isn't 0 when non TPO
      if( cover_type !== 'third-party-only' && ! updatedAnswers['VehicleRenew.Quote']['vehicle_sum_insured_amount'] ){
        return false;
      }

      // Also keep loading/waiting if full cover and the vehicle_low_usage question is not answered
      if( cover_type === 'full' ){
        if( !updatedAnswers['VehicleRenew.Quote']['vehicle_low_usage'] ){
          return false;
        }
      }

     // Handle preventing submitting data when the chosen sum-insured is out-side the valid plate range ( which then fires a out-of-bounds email on backend)
     // This is specifically if they go back and change a plate to a sum_insured outside the price bounds of the first plate
     // There should be a second update where vue formulate kicks in with the updated sum_insured from the slider
     if( cover_type === 'full' || cover_type === 'third-party-fire-theft'  ) {

       const sum_insured = parseInt(updatedAnswers['VehicleRenew.Quote']['vehicle_sum_insured_amount']);
       const max_low = parseInt(this.answers['VehicleRenew.Plate'].vehicle_price_low);
       const max_high = parseInt(this.answers['VehicleRenew.Plate'].vehicle_price_high);

       if (sum_insured < max_low || sum_insured > max_high) {
         //   console.log('sum_insured', sum_insured, 'max_low', max_low, 'max_high', max_high )
         // console.log('cancelled quote request since invalid sum_insured within params');
         return false;
       }
     }

      // All the data should now be ready to provide to the quote API ( and prevent mismatch backend errors on the quote handler )

      // Cancel any existing out-going requests ( so they don't pile up, or change the price on different request params )
      this.axiosCancelTokenSource.cancel();

      // Request a quote
      axios.post(`${api.url + api.version}vehicle/new/premium/${this.sessionId()}`, { cancelToken: this.axiosCancelTokenSource.token, ...updatedAnswers['VehicleRenew.Quote']})
          .then(response => {
            this.quoteIsLoading = false;
            this.quoteBreakdownsByInterval = {};
            if( response.data.results && response.data.results.yearly && response.data.results.monthly ){
              const results = response.data.results;

              this.quotePremiumMonthly = results.monthly.total_cost_inc_gst;
              this.quotePremiumYearly = results.yearly.total_cost_inc_gst;
              this.quotePremiumDiscountAmount = results.yearly.discount_value_inc_gst ? results.yearly.discount_value_inc_gst : false; // only yearly for renewals
              this.quoteDiscountResellerName = results.discount_reseller_name ? results.discount_reseller_name : '';
              this.quoteErrors = false;

              // Only show both breakdowns if eligible for monthly conversion
              if (this.canConvertToMonthly) {
                this.quoteBreakdownsByInterval = {
                  monthly: response.data.results.monthly.payment_breakdown,
                  yearly: response.data.results.yearly.payment_breakdown,
                }
              } else {
                // Only show yearly breakdown if not eligible for monthly
                this.quoteBreakdownsByInterval = {
                  yearly: response.data.results.yearly.payment_breakdown,
                }
              }

              if( results.monthly.quote_debug && results.yearly.quote_debug  ){
                this.debugList = [
                    {
                      type: 'Monthly',
                      quote_debug: results.monthly.quote_debug ,
                      quote_input_debug: results.monthly.quote_input_debug
                    },
                    {
                      type: 'Yearly',
                      quote_debug: results.yearly.quote_debug ,
                      quote_input_debug: results.yearly.quote_input_debug
                    },
                ];
              }

            } else {
              // console.log(response.data);
              this.quoteErrors = true;
            }
          }, error => {
            console.error(error, "Get quote error");
            this.quoteErrors = true;
          });

    }, 200), // Add delay before requesting quote, needs about 180 for the vue elements to property show/hide/update
    toggleModal: function (title='') {
      this.modalTitle = title;
      this.modalOpen = ! this.modalOpen;
    },

    setPaymentInterval(interval) {
      this.selectedPaymentInterval = interval;

      // Use setAnswer to update single field without replacing entire step
      this.$store.commit('setAnswer', {
        step: 'VehicleRenew.Quote',
        answer: 'payment_interval',
        value: interval
      });
    },

    setPaymentIntervalAndSubmit(interval) {
      this.selectedPaymentInterval = interval;

      // Use setAnswer to update single field without replacing entire step
      this.$store.commit('setAnswer', {
        step: 'VehicleRenew.Quote',
        answer: 'payment_interval',
        value: interval
      });

      // Wait for next tick to ensure store is updated, then submit
      this.$nextTick(() => {
        this.submitHandler();
      });
    },
  },
  watch: {
    // Update the store with the local component state on change with debounce
    answers (updatedAnswers) {
      // debounce here ?
      this.getQuote(updatedAnswers);
    },
  },
  mounted () {

    this.$store.dispatch('getSchema', 'renew/vehicle-quote' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })

    this.getQuote(this.answers);
  },
  data () {
    return {
      modalOpen: false,
      modalTitle: '',
      errors: [],
      schema: [],
      quoteIsLoading: true,
      quoteErrors: false,
      quotePremiumMonthly: null,
      quotePremiumYearly: null,
      quotePremiumDiscountAmount: null,
      quoteDiscountResellerName: null,
      quoteBreakdownsByInterval: {},
      debugList: [],
      axiosCancelTokenSource:  axios.CancelToken.source(),
      selectedPaymentInterval: 'yearly',
    }
  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      sessionId: 'getSessionId',
      isLoggedIn: 'isLoggedIn',
      paymentInterval: 'getPaymentInterval',
    }),

    canConvertToMonthly() {
      const options = this.$store.state.sessions[this.sessionId()]?.backendData?.VehicleRenew?.payment_options;
      return options?.can_convert === true;
    },

    paymentOptions() {
      return this.$store.state.sessions[this.sessionId()]?.backendData?.VehicleRenew?.payment_options || {};
    },
  },
}

</script>

<style scoped lang="scss">

  .quote-box {
    position: relative;
    padding-top: 0;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.07);
    border-radius: 0;

    header {
      background: $initio-green;
      color: white;
      padding: 10px;
      border-bottom: 1px solid $light-grey;
      font-size: 10px;
      //border-top-left-radius: 5px;
      //border-top-right-radius: 5px;
    }

    &:after {
      transition: 200ms ease-in-out;
      content: '';
      display: block;
      position: absolute;
      left:0;
      right:0;
      top:0;
      bottom:0;
      background: white;
      opacity: 0;
      pointer-events: none;
    }

    .title {
      font-size:2.25rem;
    }

    .is-cta {
      filter: drop-shadow(0px 2px 11px rgba(39, 39, 39, 0.243772));
    }
  }
  .quote-box.is-loading {
    &:after {
      opacity: 0.4;
      pointer-events: auto;
    }
    .loading-spinner {
      opacity: 1;
    }
  }

  .loading-spinner {
    position: absolute;
    top: 80px;
    right: 50%;
    margin-right: -20px;
    z-index: 15;
    transition: 200ms ease-in-out;
    opacity: 0;
  }

  header,
  .quote-box__email-quote-panel,
  .quote-box__monthly-benefit {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .quote-box__monthly-benefit {
    font-weight: 900;
    font-size: 12px;
  }

  .quote-box__email-quote-panel {
    border-top: 1px solid $light-grey;
  }

  .how-monthly-works-icon-link {
    background: $light-grey;
    height: 20px;
    width: 20px;
    color: white;
    text-transform: none;
    font-weight: normal;
    margin-left: 5px;
    text-align: center;
    display: inline-block;
    border-radius: 50%;
    line-height: 20px;
    &:hover {
      background: #00A7FF;
      color: white;
    }
  }

  .quote-box__monthly-benefit {
    border-bottom: 1px solid $light-grey;
    padding: 8px;
  }

  .box-quote__email-quote-panel__link {
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 15px;
    &:hover {
      background: #f9f9f9;
    }
    svg {
      margin-right: 5px;
    }
  }

  .border-top-bottom {
    border-top: 1px solid #EEEEEE;
    border-bottom: 1px solid #EEEEEE;
  }

  .box-adjustment {
    padding:0.5rem;
  }


  .quote_debug {
    margin-top: 20px;
    position:relative;
    z-index:30;

    > .box {
      background:rgba(255,255,255,0.5);
    }

    ol li {
      margin-bottom: 15px;
      font-size: 14px;
    }
  }
</style>
<style lang="scss">

.is-visible-mobile {
  display:none;

  @include mobile() {
    display: block;
  }

}
</style>
